import styled from 'styled-components'

export const Space = styled.div`
  height: 15px;
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FlexContainerBetween = styled(FlexContainer)`
  justify-content: space-between;
`

export const FlexEndContainer = styled(FlexContainer)`
  justify-content: flex-end;
`

export const Container = styled.div`
  max-width: 600px;
  font-size: 14px;
  color: var(--text);
`

export const Title = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: var(--text);

  margin-bottom: 15px;
`

export const CodeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const QRCode = styled.img`
  width: 50%;
`

export const ButtonContainer = styled.div`
  margin: 0 7px;
`

export const Separator = styled.div`
  width: 100%;
  margin-bottom: 20px;
  border-top: 1px solid var(--hawkesBlue);
`

export const LoaderBox = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 20px;
`